import type { ChartValue, InsightsChart } from './reportResult.js';
import { formatValue } from './resultRows.js';

export function rowValueText(unit: InsightsChart['unit'], value: number): string {
  const percent = value * 100;
  if (unit === 'share') return `${Number(percent.toFixed(1))}%`;
  const sign = percent > 0 ? '+' : percent < 0 ? '-' : '';
  return `${sign}${Math.round(Math.abs(percent))}%`;
}

export function chartValueText(value: ChartValue): string {
  return `${value.metric}: ${formatValue(
    value.value,
    value.format,
    value.currency_symbol ?? undefined,
    value.precision ?? null,
  )}`;
}
